import { __awaiter } from "tslib";
import stepByStepValidate from '@/services/_helpers/stepByStepValidate';
import Vue from 'vue';
import SERVICES_CONSTANTS, { StepByStepGlossary } from '@/constants/services';
import { ActivePopupTypes } from '@/store/modules/popup/types';
const cbor = require('cbor');
export const YubikeyAuthMixin = Vue.extend({
    methods: {
        /**
         * @param initialSessionId - Опциональный параметр, необходим если сессия уже была инициирована вне метода
         * @param initialFn - Функция инициатор
         */
        YubikeyAuth(steppersName, confirmSession, callback, initialSessionId, initialFn, additionalPopupContent) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: vm.$t('popups.titles.connectYubikey'),
                    slot: {
                        name: 'yubikeyConnectionPopupChunk',
                        data: {
                            additionalPopupContent
                        },
                        on: {
                            onClickRetry: initialFn
                        }
                    }
                });
                let sessionId = null;
                let confirmations;
                const createSession = () => __awaiter(this, void 0, void 0, function* () {
                    const createSessionResponse = yield stepByStepValidate({
                        name: steppersName,
                        endpointName: StepByStepGlossary.confirmSession,
                        data: {
                            sessionId: confirmSession
                        },
                        steps: 4
                    });
                    if (!createSessionResponse.success)
                        return yield callback(createSessionResponse);
                    sessionId = createSessionResponse.data.session_id;
                    confirmations = createSessionResponse.data.confirmations;
                    prepareWebauth();
                });
                const prepareWebauth = () => __awaiter(this, void 0, void 0, function* () {
                    const webauthPayloadResponse = yield stepByStepValidate({
                        name: steppersName,
                        endpointName: 'yubikeyAuthBegin',
                        steps: 1,
                        data: {
                            sessionId,
                            data: null
                        }
                    });
                    if (!webauthPayloadResponse.success)
                        return yield callback(webauthPayloadResponse);
                    const webauthPayload = cbor.decode(webauthPayloadResponse.data);
                    let timeoutId = null;
                    if (timeoutId !== null)
                        timeoutId = null;
                    timeoutId = setTimeout(() => {
                        timeoutId = null;
                    }, SERVICES_CONSTANTS.WEBAUTH_CONNECTION_TIMEOUT);
                    webauthPayload.publicKey.timeout = SERVICES_CONSTANTS.WEBAUTH_CONNECTION_TIMEOUT;
                    try {
                        const response = yield window.navigator.credentials.get(webauthPayload);
                        completeWebauth(response);
                    }
                    catch (error) {
                        console.error(error.message, error.code);
                        const errorContent = timeoutId ? vm.$t('popups.content.connectionLost') : vm.$t('popups.content.timeoutEstimated');
                        vm.$store.dispatch('popupModule/openPopup', {
                            type: ActivePopupTypes.action,
                            letDefaultClose: true,
                            title: vm.$t('popups.titles.yubikeyConnection'),
                            content: errorContent,
                            slot: {
                                name: 'YubikeyErrorPopupChunk',
                                data: {
                                    sessionId,
                                    showAccessRepair: true
                                },
                                on: {
                                    onSubmit: prepareWebauth
                                }
                            }
                        });
                    }
                });
                const completeWebauth = (webauthResponse) => __awaiter(this, void 0, void 0, function* () {
                    const completeResponse = yield stepByStepValidate({
                        name: steppersName,
                        endpointName: 'yubikeyAuthComplete',
                        data: {
                            sessionId,
                            payload: cbor.encode({
                                credentialId: webauthResponse.rawId,
                                authenticatorData: webauthResponse.response.authenticatorData,
                                clientDataJSON: webauthResponse.response.clientDataJSON,
                                signature: webauthResponse.response.signature
                            })
                        }
                    });
                    yield callback(completeResponse, sessionId, confirmations);
                });
                if (initialSessionId) {
                    sessionId = initialSessionId;
                    prepareWebauth();
                }
                else
                    createSession();
            });
        }
    }
});
